export default __webpack_public_path__ + "static/media/ask1.e96b576a.svg";